const LAST_AUTHED_PATH_KEY = "afrimed:last_authed_path";
const LAST_AUTHED_PATH_USER_KEY = "afrimed:last_authed_path_user_id";

function isTransientPath(path = "") {
  const value = String(path || "").trim();
  return value.startsWith("/settings/doctor/p/stripe-connect-launch");
}

function normalizePath(path = "") {
  const value = String(path || "").trim();
  if (!value.startsWith("/") || isTransientPath(value)) return "";
  return value;
}

export function writeLastAuthedPath(path, userId = "") {
  const uid = String(userId || "").trim();
  const cleanPath = normalizePath(path);
  if (!uid || !cleanPath) return;

  try {
    localStorage.setItem(LAST_AUTHED_PATH_KEY, cleanPath);
    localStorage.setItem(LAST_AUTHED_PATH_USER_KEY, uid);
  } catch {
    // ignore storage failures
  }
}

export function readLastAuthedPath(userId = "") {
  const uid = String(userId || "").trim();
  if (!uid) return "";

  try {
    const owner = String(localStorage.getItem(LAST_AUTHED_PATH_USER_KEY) || "").trim();
    if (!owner || owner !== uid) return "";
    return normalizePath(localStorage.getItem(LAST_AUTHED_PATH_KEY) || "");
  } catch {
    return "";
  }
}

export function clearLastAuthedPath(userId = "") {
  const uid = String(userId || "").trim();
  try {
    const owner = String(localStorage.getItem(LAST_AUTHED_PATH_USER_KEY) || "").trim();
    if (uid && owner && owner !== uid) return;
    localStorage.removeItem(LAST_AUTHED_PATH_KEY);
    localStorage.removeItem(LAST_AUTHED_PATH_USER_KEY);
  } catch {
    // ignore storage failures
  }
}
